import type { QuoteFile } from '../types'

/**
 * Is this file an SVG?
 *
 * `QuoteFile.type` is optional, and plenty of stored records don't have it — the Cloudinary→S3
 * migration preserves a missing `type` while adding `s3PublicKey` (see `migrateMediaFile`), and
 * `s3PainterPhoto` never set one. Reading `file.type.includes('svg')` on one of those threw and
 * took down whichever dialog was rendering it (#23950).
 *
 * `type` alone isn't enough to answer safely either: falling back to `''` would quietly route a
 * `type`-less SVG down the raster branch. So check the other fields that already carry the format
 * — `format`, then the `src`/`s3PublicKey` extension, which is what `isImageFile` in the media
 * migration does too.
 */
export function isSvgFile(file?: Pick<QuoteFile, 'type' | 'format' | 'src' | 's3PublicKey'> | null): boolean {
  if (!file) {
    return false
  }

  if (file.type?.toLowerCase().includes('svg')) {
    return true
  }

  if (file.format?.toLowerCase() === 'svg') {
    return true
  }

  // Strip any query string before looking at the extension — `…/logo.svg?v=2` is still an svg.
  return [file.src, file.s3PublicKey].some((path) => path?.split('?')[0]?.toLowerCase().endsWith('.svg'))
}
